module.exports = __webpack_public_path__ + "img/tile-02.56169eb2.png";